<template>
  <div class="modal-habit habit-success">
    <ul v-if="response">
      <li
        v-for="(state, day) in response.history"
        :key="day"
        :class="{ 'habit-done': state === true, 'habit-fail': state === false }"
      >
        <figure>
          <!-- TODO extract svg -->
          <svg
            v-if="state !== null"
            width="34px"
            height="34px"
            viewBox="0 0 34 34"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="1_zero" transform="translate(-32.000000, -284.000000)" fill="#FFFFFF">
                    <g id="Ukoly/Cíl-Ano-Ne" transform="translate(16.000000, 228.000000)">
                        <g id="Group" transform="translate(16.000000, 56.000000)">
                            <g id="zvyk-bily-splneno">
                                <path d="M17,34 C7.61115925,34 0,26.3888407 0,17 C0,7.61115925 7.61115925,0 17,0 C26.3888407,0 34,7.61115925 34,17 C34,26.3888407 26.3888407,34 17,34 Z M15.5187855,23.4286547 L26.0542694,12.8666963 C26.4120177,12.508049 26.4120177,11.9265098 26.0542694,11.5678625 L24.7586911,10.2690286 C24.4009427,9.91032381 23.8208613,9.91032381 23.4630556,10.2690286 L14.8709677,18.8826501 L10.859525,14.861127 C10.5017766,14.5024796 9.92169516,14.5024796 9.56388952,14.861127 L8.26831129,16.1599609 C7.9105629,16.5186082 7.9105629,17.1001474 8.26831129,17.4587947 L14.22315,23.4285973 C14.5809556,23.7873021 15.1609798,23.7873021 15.5187855,23.4286547 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </figure>
        <abbr :title="getFullNameDay(day)">{{ getShortNameDay(day) }}</abbr>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      keys: ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']
    }
  },
  methods: {
    getShortNameDay(day) {
      const days = this.keys.indexOf(day)
      const date = moment()
        .startOf('week')
        .add(days, 'days')

      return date.format('dd')
    },
    getFullNameDay(day) {
      const days = this.keys.indexOf(day)
      const date = moment()
        .startOf('week')
        .add(days, 'days')

      return date.format('dddd')
    }
  }
}
</script>
